import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.57284 11.448L5.58332 13.4375V1.35417C5.58332 1.02006 5.31326 0.75 4.97916 0.75C4.64505 0.75 4.37499 1.02006 4.37499 1.35417V13.4375L2.38547 11.448C2.14924 11.2118 1.76741 11.2118 1.53118 11.448C1.29495 11.6842 1.29495 12.066 1.53118 12.3023L4.12486 14.896C4.36049 15.1316 4.66982 15.2494 4.97916 15.2494C5.28849 15.2494 5.59782 15.1316 5.83345 14.896L8.42713 12.3023C8.66336 12.066 8.66336 11.6842 8.42713 11.448C8.19091 11.2118 7.80907 11.2118 7.57284 11.448ZM14.4688 4.55202C14.705 4.31579 14.705 3.93396 14.4688 3.69773L11.8751 1.10404C11.6395 0.868417 11.3302 0.75 11.0208 0.75C10.7115 0.75 10.4022 0.867812 10.1665 1.10344L7.57284 3.69712C7.33661 3.93335 7.33661 4.31519 7.57284 4.55142C7.80907 4.78765 8.19091 4.78765 8.42713 4.55142L10.4167 2.5619V14.6458C10.4167 14.9799 10.6867 15.25 11.0208 15.25C11.3549 15.25 11.625 14.9799 11.625 14.6458V2.5625L13.6145 4.55202C13.8507 4.78825 14.2326 4.78825 14.4688 4.55202Z"
      fill="#151718"
    />
  </svg>
);

const SortingIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default SortingIcon;
